import { Link } from "react-router-dom";

import useAppUser from "src/hooks/app-user";
import usePageTitle from "src/hooks/page-title";
import { i18n } from "src/i18n";
import Trans from "src/components/trans/trans";
import Button from "src/components/Buttons/Button";

require("./not-found.scss");

const NotFound = () => {
    usePageTitle(i18n._("Cette page n'existe pas"));
    const { user } = useAppUser();

    return (
        <div className="not-found-page">
            <h1>404</h1>
            <div className="header">
                <div className="overlay">
                    <p>
                        <Trans>Vous êtes perdu !</Trans>
                    </p>
                </div>
            </div>
            <div className="body">
                <div className="rounded-card">
                    <div className="card-body">
                        <p className="type">
                            <Trans>Cette page n'existe pas</Trans>
                        </p>
                        <p className="desc">
                            <Trans>
                                Si vous pensez qu'il devrait y avoir une page ici, contactez nous pour nous le signaler.
                            </Trans>
                        </p>
                        {user !== undefined ? (
                            <Link to="/">
                                <Button color="primary" variant="floating">
                                    <Trans>Retourner à l'accueil</Trans>
                                </Button>
                            </Link>
                        ) : (
                            <a href="https://volum.co/">
                                <Button color="primary" variant="floating">
                                    <Trans>Retourner à l'accueil</Trans>
                                </Button>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
